import { useTranslation } from 'react-i18next';
import { runReportCopyForEmail } from '@/header/lockedTopicActions.utilities';
import { setShowModal } from '@/reportEditor/pdfExport.actions';
import { fcCopy, fcPdfExport } from '@seeqdev/icons/seeq';
import { Icon } from '@seeqdev/qomponents';

export const LockedTopicActions = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flexColumnContainer tw:mr-2 tw:items-center tw:justify-center tw:gap-3"
      data-testid="locking-actions">
      <Icon
        icon={fcPdfExport}
        tooltip={t('REPORT.EDITOR.SAVE_AS_PDF_BUTTON_TITLE')}
        tooltipPlacement="bottom"
        type="theme-light"
        large={true}
        onClick={() => setShowModal(true)}
        testId="pdfExportIcon"
        extraClassNames="sq-navbar-default"
      />
      <Icon
        icon={fcCopy}
        tooltip={t('REPORT.EDITOR.COPY_FOR_EMAIL')}
        tooltipPlacement="bottom"
        type="theme-light"
        large={true}
        onClick={runReportCopyForEmail}
        testId="copyForEmailIcon"
        extraClassNames="sq-navbar-default"
      />
    </div>
  );
};
